import { motion, AnimatePresence } from 'framer-motion';
import { FaWifi } from 'react-icons/fa';
import { useOnlineStatus } from '../hooks/useUtils';

const OfflineBanner = () => {
    const isOnline = useOnlineStatus();

    return (
        <AnimatePresence>
            {!isOnline && (
                <motion.div
                    initial={{ y: -50, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -50, opacity: 0 }}
                    transition={{ type: 'spring', damping: 20 }}
                    className="fixed top-0 left-0 right-0 z-[9999] bg-red-600 text-white text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-2 shadow-lg"
                >
                    <FaWifi className="w-4 h-4 animate-pulse" />
                    You're offline. Check your internet connection.
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default OfflineBanner;
